export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#0081D3',
    light: '#e5f2fa',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#43C2BD',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#3F5C6D',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow:'#292D32'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F4F9FF',
    paper: '#FFF',
    default: '#FFF',
    header: '#11233F',
    footer: '#F4F9FF',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#43C2BD',
    tableHead: '#11233F',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#11233F',
    secondary: 'rgb(240,243,243)',
    light: '#ebe8e7',
    arrow: '#BACE60',
    secondaryLight: '#F9F9F5'
  },
  verticalBar: {
    used: '#0081D3',
    unused: '#e5f2fa',
    unlimited: '#C0C0C0',
  }
};